import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { BaseComponent } from 'src/app/base/base.component';

@Component({
  selector: 'app-invitesent',
  templateUrl: './invitesent.component.html',
  styleUrls: ['./invitesent.component.css']
})
export class InvitesentComponent extends BaseComponent implements OnInit {

  constructor(
    private router: Router
  ) {
    super();
    this._pageTitle = '';
  }

  ngOnInit(): void {
  }

  close() {
    this.router.navigate(['bottomtabs/home'])
  }
}
